import { MediaDetailCarousel } from "@coworker/apprestructured/src/launch-media/components/MediaDetailCarousel/MediaDetailCarousel";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { FixaTextArea } from "@coworker/apprestructured/src/shared/wrappers/FixaTextArea/FixaTextArea";
import { useTranslation } from "@coworker/locales";
import { useState } from "react";
import styles from "../../media-detail-page.module.css";

type WorkBriefStepProps = {
  images: string[];
};

export const WorkBriefStep = ({ images }: WorkBriefStepProps) => {
  const { t } = useTranslation();
  const [qualitativeGoal, setQualitativeGoal] = useState("");
  const [localSafetyRequirements, setLocalSafetyRequirements] = useState("");

  return (
    <>
      <MediaDetailCarousel
        images={images}
        title={t("workBriefString")}
        imageAlt={`${t("workBriefString")} Images`}
      />

      <FixaText tagName="h2" className={styles["mediaTitle"]}>
        {t("workBriefString")}
      </FixaText>

      <div className={styles["field"]}>
        <FixaText className={styles["title"]}>
          {t("qualitativeGoalString")}
        </FixaText>

        <FixaTextArea
          id={"qualitativeGoal"}
          value={qualitativeGoal}
          onChange={(e) => setQualitativeGoal(e.target.value)}
          label={t("whatShouldTheCustomerExperienceString")}
        />
      </div>

      <div className={styles["field"]}>
        <FixaText className={styles["title"]}>
          {t("localSafetyRequirementsString")}
        </FixaText>

        <FixaTextArea
          id={"localSafetyRequirements"}
          value={localSafetyRequirements}
          onChange={(e) => setLocalSafetyRequirements(e.target.value)}
          label={t("addAnyLocalSafetyRequirementsToConsiderString")}
        />
      </div>
    </>
  );
};
